import { createSlice } from '@reduxjs/toolkit';

interface CartState {
	value: {};
}

const initialState: CartState = {
	value: {},
};

export const cartSlice = createSlice({
	name: 'cart',
	initialState,
	reducers: {
		setCart: (state, supplierCatalog) => {
			state.value = supplierCatalog.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setCart } = cartSlice.actions;

export default cartSlice.reducer;
